import { render, staticRenderFns } from "./ChatHistory.vue?vue&type=template&id=7935d259&scoped=true&"
import script from "./ChatHistory.vue?vue&type=script&lang=js&"
export * from "./ChatHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChatHistory.vue?vue&type=style&index=0&id=7935d259&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7935d259",
  null
  
)

export default component.exports